import FormattedPhoneNumber from 'I18n/components/FormattedPhoneNumber';
import { jsx as _jsx } from "react/jsx-runtime";
export const getFormattedPhoneNumber = (countryCode, phoneNumber) => {
  // Japanese phone numbers returned from the endpoint don't have the country code
  // This is on purpose, as Japanese ppl aren't used to seeing the +81 prefix
  // So we'll just render Japanese numbers as is (without FormattedPhoneNumber)
  if (countryCode === 'JP') {
    return phoneNumber;
  }
  return /*#__PURE__*/_jsx(FormattedPhoneNumber, {
    value: `+${phoneNumber}`
  });
};
export const getPhoneNumberUrl = (countryCode, phoneNumber) => {
  // Includes plus sign to support international calling. Also adds country
  // code for Japanese numbers (81) because it is not returned by the endpoint
  return `tel:+${countryCode === 'JP' ? '81' : ''}${phoneNumber}`;
};